module.exports = __webpack_public_path__ + "img/7.efc35e64.png";